import { render, staticRenderFns } from "./transferRecipients.vue?vue&type=template&id=33d22d1a"
import script from "./transferRecipients.vue?vue&type=script&lang=js"
export * from "./transferRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports